import Form from './component';

export default Form;
